export { default as default } from './AfegeixALaLlista';
